import en from '../../../components/i18nProvider/en';
import { Iprefix } from '../../../hooks/useTranslation';

const translatePrefix: Iprefix = 'custodyWallet';

export const getTabTranslatePrefix = (tab: keyof (typeof en)['custodyWallet']) =>
  (translatePrefix + '.' + tab) as Iprefix;
